// Technology color mapping for consistent branding across components
export const TECH_COLORS = {
    // Backend
    'LARAVEL': '#8A4FFF',
    'PHP': '#8A4FFF',
    'NODEJS': '#68A063',
    'NODE': '#68A063',
    'EXPRESS': '#68A063',
    'PYTHON': '#3776AB',
    'DJANGO': '#3776AB',
    'FLASK': '#3776AB',
    'RUBY': '#CC342D',
    'RAILS': '#CC342D',

    // Frontend
    'REACT': '#61DAFB',
    'VUE': '#4FC08D',
    'ANGULAR': '#DD0031',
    'JAVASCRIPT': '#F7DF1E',
    'TYPESCRIPT': '#3178C6',

    // Mobile
    'SWIFT': '#F05138',
    'KOTLIN': '#7F52FF',
    'FLUTTER': '#02569B',
    'REACT NATIVE': '#61DAFB',

    // Database
    'MYSQL': '#4479A1',
    'POSTGRESQL': '#336791',
    'MONGODB': '#47A248',
    'FIREBASE': '#FFCA28',
    'REDIS': '#DC382D',

    // AI/ML
    'LANGCHAIN': '#4B7BE5',
    'LANGGRAPH': '#FF6B6B',
    'MILVUS': '#FF8C42',
    'OPENROUTER': '#00C853',
    'GEMINI': '#4285F4',

    // Other
    'HTML': '#E34F26',
    'CSS': '#1572B6',
    'SASS': '#CC6699',
    'BOOTSTRAP': '#7952B3',
    'TAILWIND': '#38B2AC',
    'GITHUB': '#24292E',
    'DOCKER': '#2496ED',
    'AWS': '#FF9900',
    'LINUX': '#FCC624'
};

export function getTechColor(tech) {
    const normalizedTech = (tech || '').toUpperCase().trim();
    return TECH_COLORS[normalizedTech] || '#6B7280'; // Default gray
}
